import GridFormActionIds from './grid_form_action_ids';

export default [
	{
		id: GridFormActionIds.CREATE,
		name: 'actions.add',
		icon: 'add',
		style: 'primary'
	},
	{
		id: GridFormActionIds.UPDATE,
		name: 'actions.update',
		icon: 'edit',
		style: 'primary'
	},
	{
		id: GridFormActionIds.CANCEL,
		name: 'actions.cancel',
		style: 'cancel'
	},
	{
		id: GridFormActionIds.EDIT,
		gridActionType: 'member',
		icon: 'edit'
	},
	{
		id: GridFormActionIds.DESTROY,
		gridActionType: 'member',
		icon: 'destroy'
	}
];
